import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type { Store as StoreService } from '@warp-drive/core';
import type RouterService from '@ember/routing/router-service';

export default class AuthenticatedSyfPostEnrollmentRoute extends Route {
  @service declare store: StoreService;
  @service declare router: RouterService;

  beforeModel() {
    // No match participant or employee record: nothing to show, as in enrollment.ts.
    if (!this.modelFor('authenticated.syf')) {
      this.router.transitionTo('authenticated.dashboard');
    }
  }

  model() {
    return this.modelFor('authenticated.syf');
  }
}
